import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import TransactionReportsPage from "./transactionReports.page";
import NotificationConfigurationDialog from "../../components/dialog/notification-configuration-dialog";
import AccessRights from "../../../../configs/constants/accessRights";

export default function TransactionReportsContainer() {
  const providers = [{ value: "tng", label: "Touch 'n Go" }];

  const navigate = useNavigate();

  const [provider, setProvider] = useState(providers[0].value);
  const [isNotificationDialogOpen, setNotificationDialogOpen] = useState(false);

  const canView = useSelector((state) => state.session.accessRights.includes(AccessRights.COMPANY_CONSUMER_ENGAGEMENT_REPORT_VIEW));

  useEffect(() => {
    if (!canView) {
      navigate('/admin');
    }
  }, [canView]);

  const handleProviderChange = (event) => {
    setProvider(event.target.value);
  };

  const onConfigureNotificationButtonClick = () => {
    setNotificationDialogOpen(true);
  };

  const handleClose = () => {
    setNotificationDialogOpen(false);
  };

  const [activeReportFilterButton, setActiveReportFilterButton] =
    useState("dailySummary");

  const reportFilterButtons = [
    { label: "Daily Summary", key: "dailySummary" }
  ];

  return (
    <>
      <TransactionReportsPage
        provider={provider}
        providers={providers}
        handleProviderChange={handleProviderChange}
        onConfigureNotificationButtonClick={onConfigureNotificationButtonClick}
        reportFilterButtons={reportFilterButtons}
        activeReportFilterButton={activeReportFilterButton}
        onReportFilterButtonClick={setActiveReportFilterButton}
      />
      {isNotificationDialogOpen && (
        <NotificationConfigurationDialog handleClose={handleClose} />
      )}
    </>
  );
}
